import { Button, Card, Typography } from '@arionbanki/arionui';
import { Modal } from 'components';
import { formatKennitala, isCancelProcessAvailable, isProcessStarted } from 'helpers';
import type { EntityProcessInfo } from 'types';
import { useDetailsCard } from './useDetailsCard';

export type DetailsCardProps = Readonly<{
	checked?: boolean;
	info: EntityProcessInfo;
	onClick: (id: string) => void;
}>;

export function DetailsCard(props: DetailsCardProps) {
	const { checked, info } = props;
	const { disabledButton, disabledCard, kennitala, name, roles } = info;
	const { btnLabel, flowType, onClose, redirect, select, t, ...ctx } = useDetailsCard(props);
	return (
		<Card checked={checked} className="px-3 py-4" disabled={disabledCard} onClick={select}>
			<div className="row">
				<div className="col-12 col-md-6">
					<Typography TagName="h6">{name}</Typography>
				</div>
				<div className="col-12 col-md-6 text-md-end">
					{isCancelProcessAvailable(ctx.IS_EMPLOYEE_WEB, info, flowType) && (
						<Button className="mb-3" mode="stroked" onClick={ctx.onClickCancel} size="small">
							{t('reset_process', 'userboard')}
						</Button>
					)}
					{disabledCard && btnLabel && (
						<Button
							className="mb-3 ms-2"
							disabled={disabledButton}
							mode="stroked"
							onClick={redirect}
							size="small"
						>
							{btnLabel}
						</Button>
					)}
					{isProcessStarted(flowType, ctx.processStatus) && (
						<Button
							className="mb-3 ms-2"
							disabled={disabledButton}
							mode="stroked"
							onClick={redirect}
							size="small"
						>
							{t('PROCESS_STARTED', 'userboard')}
						</Button>
					)}
				</div>
				<div className="col-12 col-md-3">{formatKennitala(kennitala)}</div>
				<div className="col-12 col-md-9 text-md-end">
					<span>{roles}</span>
				</div>
			</div>
			<Modal background="dim" handleClose={onClose} isOpen={ctx.isModalOpen} width="100%">
				<div className="row text-center my-5">
					<div className="col-12 mb-5">
						<Typography TagName="h5">{t('are_you_sure', 'userboard')}</Typography>
					</div>
					<div className="col-6">
						<Button mode="primary" onClick={ctx.onCancelProcess} size="small" width="80%">
							{t('yes')}
						</Button>
					</div>
					<div className="col-6">
						<Button mode="secondary" onClick={onClose} size="small" width="80%">
							{t('no')}
						</Button>
					</div>
				</div>
			</Modal>
		</Card>
	);
}
